import { useQuery } from '@tanstack/react-query';
import type { LatLng } from '@/shared/types';
import { graphHopperDirectionQueryOption } from './direction.options';

const useDirection = (
	routeId: string,
	origin?: LatLng | null,
	destination?: LatLng | null,
) => {
	const {
		data: direction,
		isLoading,
		error,
	} = useQuery(graphHopperDirectionQueryOption(routeId, origin, destination));

	return { direction, isLoading, error };
};

export default useDirection;
